// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IntroVideo_wrapper__37kLF","fullScreen":"IntroVideo_fullScreen__BQU3C","video":"IntroVideo_video__3jhxD"};